var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "vacancies-card",
      attrs: { href: _vm.vacancyInfo.detailPageUrl },
    },
    [
      _c(
        "div",
        { staticClass: "vacancies-card__content" },
        [
          _c("div", { staticClass: "vacancies-card__header" }, [
            _c("div", { staticClass: "vacancies-card__header-wrapper" }, [
              _c("img", {
                staticClass: "vacancies-card__header-icon",
                attrs: { src: "/images/career/pin.svg", alt: "" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "vacancies-card__header-title" }, [
                _vm._v(_vm._s(_vm.vacancyInfo.city.value)),
              ]),
            ]),
            _vm._v(" "),
            _vm.vacancyInfo.specialization
              ? _c(
                  "div",
                  { staticClass: "vacancies-card__tags" },
                  [
                    _c(
                      "tag",
                      {
                        staticClass: "vacancies-card__tags-item",
                        attrs: { theme: "gray" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.vacancyInfo.specialization.value) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "z-caption",
            { staticClass: "vacancies-card__title", attrs: { tag: "h3" } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.vacancyInfo.name) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }